import DefaultModal from "Components/Modal/DefaultModal";
import React, { useState } from "react";
import {
	Button,
	Card,
	CardBody,
	Col,
	Input,
} from "reactstrap";

export default function MessageModal({
	isOpen,
	setIsOpen,
	usersToNotify,
	setUsersToNotify
}) {
	const [message, setMessage] = useState("");

	const currentLength = message?.length ?? 0;
	const credits = Math.max(0, Math.ceil(currentLength / 160));
	const remainingChars = 1377 - currentLength;

	const resetModal = () => {
		setUsersToNotify([]);
		setMessage("");
		setIsOpen(false);
	};

	const handleSendMessage = () => {
		alert(
			`Message "${message}" is sent to users with ids: ${usersToNotify
				.map((u) => u.adminId)
				.join(",")}`
		);
		resetModal();
	};

	return (
		<DefaultModal
			modal={isOpen}
			header="Bulk-SMS versturen "
			headerColor={""}
			toggle={() => setIsOpen(false)}
			showFooterBtns={false}
			classes="modal-dialog__over feedback-modal-style planscreen__modal planscreen__modal--sms wc-500"
		>
			<Card>
				<CardBody className="py-4 border-top d-flex flex-column gap-4">
					<Col>
						<Input
							type="textarea"
							name="vMemo"
							id="vMemo"
							rows={9}
							maxLength={1377}
							value={message}
							onChange={(e) => setMessage(e.target.value)}
						/>
					</Col>

					<div className="d-flex align-items-center pt-4 border-top">
						<p className="me-3 mb-0">
							Aantal tekens / SMS :
						</p>

						<p className="mb-0 remaining-chars">
							{remainingChars} / {credits}
						</p>
					</div>

					<div className="d-flex gap-5 justify-content-center">
						<Button
							outline
							className={`btn-outline-primary-blue ${
								message?.length > 1 ? "" : "disabled"
							}`}
							onClick={handleSendMessage}
							type="button"
							color="primary"
						>
							Verzenden
						</Button>

						<Button
							outline
							className="btn-outline-primary-blue"
							onClick={resetModal}
							type="button"
							color="primary"
						>
							Annuleren
						</Button>
					</div>
				</CardBody>
			</Card>
		</DefaultModal>
	);
}